exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".img-avatar[data-v-212b77e6] {\n  display: block;\n  margin: 1.5em auto 0;\n  max-width: 300px;\n  height: 300px;\n}\n.img-avatar.default-image[data-v-212b77e6] {\n  border-radius: 50%;\n}\nlabel[disabled][data-v-212b77e6] {\n  opacity: 0.5;\n}", ""]);

// exports
